__turbopack_context__.v({
  "button": "icon-button-module-scss-module__WSsQUW__button",
  "lightMode": "icon-button-module-scss-module__WSsQUW__lightMode",
  "small": "icon-button-module-scss-module__WSsQUW__small",
});
